const BuildItemType = {
  BOT: 1,
  DATA_INTEGRATION: 2
}

export default BuildItemType
